import {chainWalk, deepCopyObject} from "../../../util/Util";
import {ASSET_CONFIG_ATTRIBUTES, ZANCASORT_ASSET_TYPE} from "../../../util/Constants";

const ZS_CONFIG_ATTRIBUTES = ASSET_CONFIG_ATTRIBUTES[ZANCASORT_ASSET_TYPE];

export const updateConfigurationsInZancaSortAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes[ZS_CONFIG_ATTRIBUTES.TEST_CONFIG] =
        chainWalk(() => JSON.stringify(configurations.testConfig), "[]")
    updatedAsset.assetDetails.assetAttributes[ZS_CONFIG_ATTRIBUTES.LOCATION_CONFIG] =
        chainWalk(() => JSON.stringify(configurations.locationConfig), "[]")
    updatedAsset.assetDetails.assetAttributes[ZS_CONFIG_ATTRIBUTES.TIER_CONFIG] =
        chainWalk(() => {
            const tierConfigObj = {};
            (configurations.tierConfig || []).forEach(tier => {
                tierConfigObj[tier.tierName] = {
                    capacity: tier.capacity,
                    levels: `${tier.startLevel}:${tier.endLevel}`
                };
            });
            return JSON.stringify(tierConfigObj);
        }, "{}")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/datamodel/ZancaSortAssetModelResource.js